/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";
import clsx from "clsx";
import useErrors from "../../Utils/userErrors";
import ErrorText from "../ErrorText";
import Tooltip from "./../Tooltip";
import CheckboxInputProps from "./CheckboxInputProps";
import "./CheckboxInput.scss";

export default function CheckboxInput(props: CheckboxInputProps) {
    const { error, errorTexts } = useErrors(props);
    return (
        <Box className={clsx("lan-checkboxinput", props.className)} sx={props.sx}>
            <div className="lan-checkboxinput__input">
                <FormControlLabel
                    className={clsx("lan-checkboxinput__label", error && "lan-checkboxinput__label--error")}
                    control={<Checkbox disabled={props.readonly} size={props.size} style={props.style} />}
                    label={props.caption}
                    checked={props.value}
                    onChange={(_, checked) => props.onChange?.(checked)}
                    disabled={props.readonly}
                />
                {props.tooltip && (
                    <div>
                        <Tooltip title={props.tooltip} />
                    </div>
                )}
            </div>
            <FormHelperText error={error} >
                <ErrorText errors={errorTexts} />
            </FormHelperText>
        </Box>
    );
}
